/**
 * @generated SignedSource<<551dba2675f09b90c1ded9ed27d88d82>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraNumberFieldFormatStyle = "CURRENCY" | "DECIMAL" | "PERCENT" | "UNIT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef$data = {
  readonly fieldId: string;
  readonly formatConfig?: {
    readonly formatStyle: JiraNumberFieldFormatStyle | null | undefined;
    readonly formatUnit: string | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly name: string;
  readonly number: number | null | undefined;
  readonly type: string;
  readonly " $fragmentSpreads": FragmentRefs<"number_issueFieldNumberReadviewFull_NumberReadView">;
  readonly " $fragmentType": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef";
};
export type number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef$key = {
  readonly " $data"?: number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "number_issueFieldNumberReadviewFull_NumberReadView"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "number"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraNumberFieldFormatConfig",
          "kind": "LinkedField",
          "name": "formatConfig",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "formatStyle"
            },
            {
              "kind": "ScalarField",
              "name": "formatUnit"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraNumberField"
};

(node as any).hash = "b1237a150436223d181b77d20b811582";

export default node;
